var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcTelegram = function SvgIcTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_telegram_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 37
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.742 36.002c9.941 0 18-8.06 18-18 0-9.941-8.059-18-18-18-9.94 0-18 8.059-18 18 0 9.94 8.06 18 18 18Z",
    fill: "#00A0E3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ic_telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4EA4F6",
    d: "M-19.367-26.908h76.332v90.213h-76.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.226 17.202s8.846-3.63 11.914-4.909c1.175-.51 5.164-2.147 5.164-2.147s1.84-.716 1.687 1.023c-.051.715-.46 3.22-.87 5.93-.613 3.835-1.277 8.028-1.277 8.028s-.103 1.176-.972 1.38c-.87.205-2.3-.715-2.556-.92-.205-.153-3.835-2.454-5.165-3.579-.358-.307-.767-.92.052-1.636 1.84-1.687 4.039-3.784 5.368-5.113.614-.614 1.227-2.045-1.33-.307a436.683 436.683 0 0 1-7.209 4.858s-.818.51-2.352.05c-1.534-.46-3.323-1.073-3.323-1.073s-1.227-.767.87-1.585Z",
    fill: "#fff"
  }))));
};
export default SvgIcTelegram;